var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlagSrbsko(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3223_17547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37262 0 0 5.37262 0 12C0 13.4678 0.264047 14.874 0.746391 16.1739H23.2537C23.736 14.874 24 13.4678 24 12C24 5.37262 18.6274 0 12 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0C6.84012 0 2.44161 3.2565 0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10156 6.78259V12.7688C3.10156 16.174 7.55005 17.2174 7.55005 17.2174C7.55005 17.2174 11.9985 16.174 11.9985 12.7688V6.78259H3.10156Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94531 7.82613H10.1627V5.73916L9.11925 6.26088L7.55405 4.69568L5.9888 6.26088L4.94531 5.73916V7.82613Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9584 13.6024L7.56709 10.2111L4.17578 13.6024L5.28255 14.7091L7.56709 12.4246L9.85164 14.7091L10.9584 13.6024Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9584 10.4347H9.37609C9.46506 10.2812 9.51681 10.1033 9.51681 9.91311C9.51681 9.33674 9.04961 8.86963 8.47333 8.86963C8.07512 8.86963 7.72933 9.09266 7.55341 9.42055C7.37748 9.09271 7.03169 8.86963 6.63348 8.86963C6.0572 8.86963 5.59 9.33674 5.59 9.91311C5.59 10.1033 5.64175 10.2812 5.73072 10.4347H4.17578C4.17578 11.0111 4.67777 11.4782 5.254 11.4782H5.21927C5.21927 12.0546 5.68642 12.5217 6.26275 12.5217C6.26275 13.032 6.62922 13.4559 7.1132 13.5467L6.29102 15.403C6.68505 15.5632 7.11564 15.6522 7.56714 15.6522C8.01864 15.6522 8.44923 15.5632 8.84327 15.403L8.02108 13.5467C8.50506 13.456 8.87153 13.032 8.87153 12.5217C9.44786 12.5217 9.91502 12.0546 9.91502 11.4782H9.88028C10.4565 11.4782 10.9584 11.011 10.9584 10.4347V10.4347Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3223_17547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagSrbsko);
export default __webpack_public_path__ + "static/media/icon_flag_srbsko.f41eb42d6e7f8e9f551b3fa11b29950d.svg";
export { ForwardRef as ReactComponent };